import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Container,Button } from 'react-bootstrap';
import Logout from './Logout.js';
import axios from '../axiosConfig';
import AddsCard from './AddsCards.js';
import { GoogleOAuthProvider } from '@react-oauth/google';
import register_new from '../assets/images/register_new.png';
import sign_in from '../assets/images/sign_in.png';
import SecNavbar from './SecNavbar.js';



/* Main component used in all pages.
It contains the sign in and register buttons, the logout button and the adds cards */

const Main = ({componentList=[], full}) => {

  
  const navigate = useNavigate();
  const proxyUrl = process.env.REACT_APP_PROXY;
  // console.log("ttttttttttttttttttttt");
  // console.log(proxyUrl + "aaaaa");
  const handleRegisterClick = () => {
    navigate('/myaccount/register'); // Redirect to the Register page
  };
  const handleSignInClick = () => {
    navigate('/myaccount/signin'); // Redirect to the Sign In page
  };
  const [allAdds, setallAdds] = useState([]);

    useEffect(() => {
      const fetchAdds = async () => {
        try {
          const response = await axios.get('/api/adds'); 
          
          setallAdds(response.data.data);
          
        } catch (error) {
          console.error('Error while fetching adds : ', error);
        }
      };
      fetchAdds();
    }, []);



  return (
    <GoogleOAuthProvider clientId="1061321282169-jfaln3p3cvt868evp4jm0hlnpu5qn5e9.apps.googleusercontent.com">

    <Container fluid className="d-flex justify-content-center" style={{paddingRight : '0'}}>
      <Row className="w-100 p-0">
        <Col md={3} className="d-flex flex-column align-items-start">
          <Row className="d-flex flex-column align-items-start">
            <Col className="mb-1">
              <Button
                variant="link"
                type="submit"
                className="form-button d-flex align-items-end"
                style={{ 
                  border: 'none', 
                  textDecoration: 'none', 
                  display: 'flex', 
                  alignItems: 'center',
                  paddingLeft: "0",
                }}
                onClick={handleSignInClick}
              >
                <div 
                  style={{
                    backgroundColor: '#5000FF',
                    borderRadius: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px', 
                    height: '30px'
                  }}
                >
                  <img style={{width : "60%"}} src={sign_in} alt="sign-in" />
                </div>
                <span className="button-text" style={{ marginLeft: '10px' }}>Sign in</span>
              </Button>
            </Col>
          </Row>
          
          <Row className="d-flex flex-column align-items-start">
            <Col className="mb-2">
              <Button
                variant="link"
                type="submit"
                className="form-button d-flex align-items-end"
                style={{ 
                  border: 'none', 
                  textDecoration: 'none', 
                  display: 'flex', 
                  alignItems: 'center',
                  paddingLeft: "0",
                }}
                onClick={handleRegisterClick}
              >
                <div 
                  style={{
                    backgroundColor: '#5000FF',
                    borderRadius: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px', 
                    height: '30px'
                  }}
                >
                  <img style={{width : "60%"}} src={register_new} alt="register" />
                </div>
                <span className="button-text" style={{ marginLeft: '10px' }}>Register new account</span>
              </Button>
            </Col>
          </Row>  

          {/* <Row className="align-items-center">
            <Col xs="auto">
              <Button  
                onClick={handleRegisterClick}
                className="form-button"
                variant="link"
                style={{backgroundColor: '#5000ff', borderRadius: '10%'}}
              >
                <div 
                  style={{
                    backgroundColor: '#5000FF',
                    borderRadius: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '30px', 
                    height: '30px'
                  }}
                >
                  <img src={register_new} className="button-img" alt="register"/>
                </div>
              </Button>
            </Col>
            <Col>
              <span className="button-text">Register new account</span>
            </Col>
          </Row> */}

          <br/>
          
          {allAdds.map((add) => (
            <AddsCard key={add.id}
              image_link = {proxyUrl + add.image_link}
              add_link = {proxyUrl + add.add_link}
              title = {add.title}        
            />
            
          ))}
          <Logout />
        </Col>

        <Col md={9} className="d-flex flex-column align-items-start p-0 m-0">
          <SecNavbar />
          {componentList.map((Component, index) => (
            <div key={index} style={{width : full ? "100%" : "78%"}}>
              {Component}
            </div>
          ))}
        </Col>

        {/* <Col md={{offset : 3, span : 7}} className="d-flex flex-column align-items-start p-0">
          {componentList.map((Component, index) => (
            <div key={index} className='w-100'>
              {Component}
            </div>
          ))}
        </Col> */}
      </Row>
    </Container>
    </GoogleOAuthProvider>
  );
}

export default Main;

